import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-data-horario',
    templateUrl: './data-horario.component.html',
    styleUrls: ['./data-horario.component.css'],
    standalone: true,
    imports: [DatePipe]
})
export class DataHorarioComponent  {
  @Input() data: string;

}
